import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// require під константою — у збірці застосунку CheckPage (і його глобальний CSS) викидається
const CheckPage = process.env.REACT_APP_CHECK_ONLY ? require('./CheckPage').default : null;

// Пристрої без вирізу (Android, iPhone до X): safe-area зверху < 40px —
// там шапкам не потрібен відступ під виріз
const safeTopProbe = document.createElement('div');
safeTopProbe.style.cssText = 'position:fixed;visibility:hidden;padding-top:env(safe-area-inset-top)';
document.body.appendChild(safeTopProbe);
if (parseFloat(getComputedStyle(safeTopProbe).paddingTop) < 40) document.documentElement.classList.add('no-notch');
safeTopProbe.remove();

// Android красить статус-бар у theme-color — беремо колір першого непрозорого фону
// під верхнім краєм екрана (екрани фарбують то body, то свій контейнер)
const themeMeta = document.querySelector('meta[name="theme-color"]');
if (themeMeta) {
  const isOpaque = (c) => c && c !== 'transparent' && !/^rgba\(.*,\s*0?\.\d+\)$|^rgba\(.*,\s*0\)$/.test(c);
  // верхній колір вертикального градієнта (без напрямку або 180deg/to bottom) — щоб
  // статус-бар продовжував градієнтну шапку головного екрана
  const gradientTop = (img) => {
    const m = /^linear-gradient\((?:180deg,\s*|to bottom,\s*)?(rgba?\([^)]*\))/.exec(img);
    return m && m[1];
  };
  const topColor = (style) => [gradientTop(style.backgroundImage), style.backgroundColor].find(isOpaque);
  const rgb = (c) => (c.match(/[\d.]+/g) || []).slice(0, 3).map(Number);
  // фони карток на головній — шари .hero-bg-layer з pointer-events: none, тож
  // elementsFromPoint їх не бачить; змішуємо їхній верхній колір з прозорістю шару
  const withBgLayers = (el, base) => {
    let mix = rgb(base);
    let layered = false;
    for (const layer of el.children) {
      if (!layer.classList.contains('hero-bg-layer')) continue;
      const style = getComputedStyle(layer);
      const a = parseFloat(style.opacity);
      const c = a > 0 && topColor(style);
      if (!c) continue;
      const top = rgb(c);
      mix = mix.map((v, i) => v + (top[i] - v) * a);
      layered = true;
    }
    return layered ? `rgb(${mix.map(Math.round).join(', ')})` : base;
  };
  const syncThemeColor = () => {
    const stack = document.elementsFromPoint(window.innerWidth / 2, 1);
    for (const el of stack) {
      const base = topColor(getComputedStyle(el));
      const bg = base && withBgLayers(el, base);
      if (bg) {
        if (themeMeta.getAttribute('content') !== bg) themeMeta.setAttribute('content', bg);
        return;
      }
    }
  };
  let scheduled = false;
  const scheduleSync = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; syncThemeColor(); });
  };
  new MutationObserver(scheduleSync).observe(document.body, {
    attributes: true, attributeFilter: ['style', 'class'], childList: true, subtree: true,
  });
  window.addEventListener('scroll', scheduleSync, { passive: true, capture: true });
  // екрани, що виїжджають анімацією (налаштування, документи), у момент монтування
  // ще за краєм — під верхом тоді попередній екран; перемірюємо, коли доїхали
  window.addEventListener('animationend', scheduleSync, true);
  window.addEventListener('transitionend', scheduleSync, true);
  // поки йде анімація/перехід (напр. доводка фону після свайпу) — перемірюємо
  // щокадру, щоб статус-бар ішов разом із фоном, а не наздоганяв у кінці.
  // Обмеження за часом замість лічильника: знятий посеред переходу елемент
  // може не надіслати transitionend, і цикл крутився б вічно
  let followUntil = 0;
  let following = false;
  const follow = () => {
    followUntil = performance.now() + 1000;
    if (following) return;
    following = true;
    const tick = () => {
      syncThemeColor();
      if (performance.now() < followUntil) requestAnimationFrame(tick);
      else following = false;
    };
    requestAnimationFrame(tick);
  };
  window.addEventListener('transitionrun', follow, true);
  window.addEventListener('animationstart', follow, true);
  window.addEventListener('load', scheduleSync);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* REACT_APP_CHECK_ONLY=1 — окрема збірка лише зі сторінкою квитанції (check-site) */}
    {CheckPage ? <CheckPage /> : <App />}
  </React.StrictMode>
);
